export default __webpack_public_path__ + "static/media/featured_video.1448c93a.svg";